module.exports = __webpack_public_path__ + "static/media/GuideRecOS10Step1.6f8bf651.gif";